import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Control, Errors } from 'react-redux-form'
import Card from '../../utils/Card'
import Label from '../../utils/Label'

import RequestFormStepButtons from './stepButtons'
import SemanticInput from '../../semanticInput'

const connected = connect(store => {
  return {
    currentStep: store.requestForm.step
  }
})
export class RequestFormStep4 extends Component {
  render() {
    return (
      <div className="w-full md:w-1/2">
        <Label>Email Address:</Label>

        <Control
          model=".email"
          component={SemanticInput}
          controlProps={{
            label: 'Email Address'
          }}
          validators={{
            required: val => val.length
          }}
        />
        <Errors
          model="availabilityRequestForm.email"
          messages={{
            required: 'Enter Your Email Address'
          }}
          show="touched"
          component={props => (
            <Card color="lightOrange" small className="inline-block mt-1">
              <span className="text-lg font-bold">{props.children}</span>
            </Card>
          )}
        />

        <div className="mt-6">
          <RequestFormStepButtons />
        </div>
      </div>
    )
  }
}
export default connected(RequestFormStep4)
